// The version this phone is running (semver), from client/package.json. `npm run bump` keeps it
// the same as the server's and the newest release in CHANGELOG.md (README "Versions").
import { version } from "../../package.json";

export const APP_VERSION: string = version;
